import React, {useEffect, useRef, useState} from 'react'
import {editClient, validateSuggestion} from '../../../../components/requests'
import {useNavigate} from 'react-router-dom'
import {ModeleClient, modeleClientInitValues} from '../../../../components/Models'
import {FicheClientForm} from './FicheClientForm'
import {LoadingData} from '../../../../components/LoadingData'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'

type DataType = {
  id: number
  nom_piece: string
  etat: string
  prix: string
  prixPropose: string
  reference: string
  status: boolean
  referencePiece: string
  accepted: boolean
  refused: boolean
  marque: string
  model: string
  acceptedBlocked: boolean
  idTypePiece: number
  quantityTypePiece: number
  nomTypePiece: string
  clientDemandePieceId: number
}

const FicheClientEditModal = (props) => {
  const {
    clientId,
    ids,
    isProspect,
    setIsProspect,
    dataClient,
    feedBackClient,
    updatingClientAdresseAfterEdit
  } = props
  const navigate = useNavigate()
  const [data, setData] = useState<ModeleClient>(modeleClientInitValues)
  const [loading, setLoading] = useState(true)
  const {setStatusText, loadingBtn, setLoadingBtn} = props
  const [isProspectChecked, setIsProspectChecked] = useState(false)
  const btnCloseSuggesteRef = useRef<any>(null)

  const getClientData = () => {
    if (dataClient) {
      if (dataClient.id !== undefined && dataClient.id !== null) {
        const updatedData = {
          ...data,
          ...dataClient,
          idPays: dataClient.pays?.id,
          codeNaf: dataClient.naf?.code,
          libelleCodeNaf: dataClient.naf?.libelle,
          isConversionToClient: true,
        }
        setData({...updatedData})
      }
      setLoading(false)
    } else {
      navigate(`/vente/clients/liste`)
    }
  }

  useEffect(() => {
    getClientData()
  }, [dataClient])

  const submitForm = async (fieldsToUpdate: Partial<ModeleClient>, callback): Promise<void> => {
    const updatedData = Object.assign({...data}, fieldsToUpdate)
    var FirstRequestOk = false
    var SecondRequestOk = false

    const idToastEditAndSubmit = toast.loading('Modification du client en cours...')
    try {
      const clientRequest = await editClient(clientId, updatedData)
      if (clientRequest?.status === 200) {
        FirstRequestOk = true
        updatingClientAdresseAfterEdit(fieldsToUpdate)
        setIsProspect(false)
        toast.update(idToastEditAndSubmit, {
          render: 'Client modifié avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 5000,
        })
      }
      const feedBackRequest = await feedBackClient(ids, true, isProspect, false)
      if (feedBackRequest.status === 200) {
        SecondRequestOk = true
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
      if (FirstRequestOk && SecondRequestOk) {
        setData({...updatedData})
      }
    }
  }

  return (
    <>
      {loading ? (
        <LoadingData />
      ) : (
        <FicheClientForm
          clientId={clientId}
          data={data}
          submitForm={submitForm}
          ids={ids}
          loading={loadingBtn}
          setLoading={setLoadingBtn}
          isProspectChecked={isProspectChecked}
          setIsProspectChecked={setIsProspectChecked}
          isProspect={false}
          setIsProspect={setIsProspect}
          convertClient={true}
          btnCloseSuggesteRef={btnCloseSuggesteRef}
        />
      )}
    </>
  )
}

export default FicheClientEditModal
